import * as yup from "yup";
import AlertDialog from "../components/AlertDialog";

const joinusSchema = yup.object({
	email: yup
		.string("Email")
		.email("Enter a valid email")
		.required("Email is required"),

	password: yup
		.string("Enter your password")
		.matches(/(?=.*?[A-Z])/, 'Your password must have at least one uppercase.')
        .matches(/(?=.*?[a-z])/, 'Your password must have at least one lowercase.')
        .matches(/(?=.*?[0-9])/, 'Your password must have at least one number.')
        .matches(/(?=.*?[#?!@$%^&*-])/, 'Your password must have atleast one special character')
		.min(8, "Your password must have at least 8 characters.")
		.required("Password is required"),

	name: yup
		.string("Name")
		.required("Name is required")
		.min(3, "Name should be of minimum 3 characters length")
		.max(35, "Name should be of maximum 35 characters length"),
	age18: yup
		.boolean()
		.required(
			<AlertDialog
				open={true}
				title={"You need to confirm your age"}
				message={
					"You cannot move forward before confirming you are older than 18 years old."
				}
				btn_Orange_Text={"Go back"}
			/>
		)
		.oneOf(
			[true],
			<AlertDialog
				open={true}
				title={"You need to confirm your age"}
				message={
					"You cannot move forward before confirming you are older than 18 years old."
				}
				btn_Orange_Text={"Go back"}
			/>
		),

	userType: yup.string("Select user type"),

	companyName: yup.string("Company name"),
	companyAddress: yup.string("Company address"),
	role: yup.string("Creator role").required("Creator role is required"),

	spvName: yup.string("SPV Name"),
	spvMembers: yup.array().of(
		yup.object().shape({
			name: yup.string(), // these constraints take precedence
			email: yup.string("Email").email("Enter a valid email"), // these constraints take precedence
		})
	),
	spvCompanies: yup.array().of(
		yup.object().shape({
			name: yup.string("Company name"),
			address: yup.string("Company address"),
			email: yup.string("Email").email("Enter a valid email"),
		})
	),
});

const initialValues = {
	email: "",
	password: "",
	name: "",
	userType: "",
	country: "",
	role: "",
	age18: false,

	spvCompanies: [],
	spvMembers: [
		{
			name: "",
			email: "",
		},
	],
};

const organizationSPVSchema = yup.object().shape({
	spvName: yup.string().required("SPV name is required"),
	spvCountry: yup.string().required("SPV country is required"),
	peoples: yup.array().of(
		yup.object().shape({
			name: yup.string().min(4).required("Name is required"),
			email: yup.string().email().required("Email is required"),
		})
	),
	companies: yup.array().of(
		yup.object().shape({
			companyName: yup.string().required("Company name is required"),
			email: yup.string().email().required("Company email is required"),
			address: yup.string().required("Company address is required"),
		})
	),
});
const organizationCompanySchema = yup.object().shape({
	email: yup
		.string("Email")
		.email("Enter a valid email")
		.required("Email is required"),
	companyName: yup
		.string("Company name")
		.required("Company name is required")
		.min(3, "Company name minimum 3 characters")
		.max(35, "Company name maximum 35 characters"),
	// registrationNumber: yup
	// 	.string("Registration Number")
	// 	.required("Registration Number is required")
	// 	.min(4, "Registration number must be of 4 characters"),
	companyAddress: yup.string().required("Please provide company address").min(3,"Address must be of minimum 3 characters"),
	companyType: yup
		.string("Company type")
		.required("Company type is required"),
});

const initialValuesOrganizationCompany = {
	email: "",
	companyName: "",
	companyAddress: "a",
	// registrationNumber: "",
	companyType: "",
};
const initialValuesOrganizationSPV = {
	spvName: "",
	spvCountry: "",
	peoples: [
		{
			id: 0,
			email: "",
			name: "",
		},
	],
	companies: [
		{
			id: 0,
			companyName: "",
			email: "",
			address: "",
		},
	],
};

const JoinusValidation = {
	initialValues,
	joinusSchema,
	organizationSPVSchema,
	organizationCompanySchema,
	initialValuesOrganizationCompany,
	initialValuesOrganizationSPV,
};
export default JoinusValidation;
